<template>
  <div class="px-3 py-2 bg-transparent flex gap-2 items-center">
    <div class="relative flex-1 flex items-center">
      <textarea
        ref="textareaRef"
        :value="value"
        @input="onInput"
        @keydown="onKeydown"
        autofocus
        :readonly="loading"
        :placeholder="placeholder"
        aria-label="Digite sua mensagem"
        :class="[
          'w-full rounded-2xl border px-4 py-2 pr-14 shadow-sm focus:outline-none transition-shadow resize-none overflow-y-auto hide-scrollbar',
          dark
            ? 'border-[#444] bg-[#232324] text-gray-100 placeholder-gray-400'
            : 'border-gray-200 bg-white text-gray-900 placeholder-gray-400',
        ]"
      />
      <button
        @mousedown.prevent
        @click="onClickSend"
        :disabled="loading || !value.trim()"
        :class="[
          'absolute top-1/2 right-3 -translate-y-1/2 bg-purple-400 text-white w-9 h-9 min-h-[36px] min-w-[36px] rounded-lg flex items-center justify-center transition-colors disabled:opacity-50 p-0 hover:bg-purple-600 shadow-none',
          !(loading || !value.trim()) ? 'cursor-pointer' : 'cursor-default',
        ]"
        aria-label="Enviar mensagem"
      >
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-width="2" d="M3 20l18-8-18-8v6l15 2-15 2v6z" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
export default ({
  name: 'ChatInput',
  props: {
    value: { type: String, required: true },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Pergunte à Rose...' },
    dark: { type: Boolean, default: false },
    textareaRef: { type: Object, default: null },
  },
  emits: ['input', 'send'],
  methods: {
    onInput(this: any, e: Event) {
      this.$emit('input', (e.target as HTMLTextAreaElement).value);
      this.adjustHeight();
    },
    onKeydown(this: any, e: KeyboardEvent) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.$emit('send');
        this.$nextTick(() => {
          this.adjustHeight();
          this.focusTextarea();
        });
      }
    },
    onClickSend(this: any) {
      this.$emit('send');
      this.$nextTick(() => {
        this.adjustHeight();
        this.focusTextarea();
      });
    },
    adjustHeight(this: any) {
      const el = this.$refs.textareaRef as HTMLTextAreaElement;
      if (!el) return;
      el.style.height = 'auto';
      const minHeight = 36;
      const maxHeight = 36 * 3;
      const newHeight = Math.min(Math.max(el.scrollHeight, minHeight), maxHeight);
      el.style.height = newHeight + 'px';
    },
    focusTextarea(this: any) {
      const el = this.$refs.textareaRef as HTMLTextAreaElement;
      if (!el) return;
      el.focus();
      try {
        const len = el.value?.length ?? 0;
        el.setSelectionRange(len, len);
      } catch {}
    },
  },
  mounted() {
    this.adjustHeight();
    if ((this as any).textareaRef) {
      (this as any).textareaRef.value = this.$refs.textareaRef as HTMLTextAreaElement;
    }
  },
  watch: {
    value(this: any) {
      this.$nextTick(this.adjustHeight);
    },
  },
});
</script>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
</style>
